/* 

Menu Pdf

*/

import MenuPdf from './MenuPdf.jsx';

export default MenuPdf;